import React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { useMsal } from "@azure/msal-react";
import { PopupRequest } from '@azure/msal-browser';

const useStyles = makeStyles({
	loginPanel: {
		width: '400px',
		height: '137px',
		border: '1px solid #ccc',
		borderRadius: '10px',
		margin: 'calc((100vh - 200px) / 2) calc((100vw - 400px) / 2)'
	},
	loginHeader: {
		backgroundColor: '#169691',
		color: 'white',
		textAlign: 'center',
		padding: '5px'
	},
	loginButton: {
		margin: tokens.spacingHorizontalL,
		textAlign: 'center'
	},
	microsoftSigninButton: {
		display: 'block',
		backgroundColor: '#09A9F7',
		border: '1px solid #09A9F7',
		color: 'white',
		cursor: 'pointer',
		padding: '10px 20px',
		textDecoration: 'none',
		borderRadius: '5px',
		fontSize: '16px',
		margin: 'auto'
	}
});

const loginRequest: PopupRequest = {
  scopes: ["openid", "profile"], // for ID token; access token for API requested separately
};


const Login = () => {
	const styles = useStyles();
	const { instance } = useMsal();

	const handleLogin = () => {
		instance.loginPopup(loginRequest);
	};

	const page = (
		<div className={styles.loginPanel}>
			<div className={styles.loginHeader}>
				<h2>Anark License Portal</h2>
			</div>
			<div className={styles.loginButton}>
				<button className={styles.microsoftSigninButton} onClick={handleLogin}>
					Sign in with Microsoft Entra
				</button>
			</div>
		</div>
	)

	return page;
};

export { Login };